var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-data-contain"},[_c('img',{attrs:{"src":require("./asset/img/noData.png"),"alt":""}}),_c('p',{staticClass:"tips"},[_vm._v("暂无借款记录")])])
}]

export { render, staticRenderFns }